<template>
  <div class="affiliate-custom-widgets">
    <EmbeddedSupportInfo v-if="contactInfoEnabled" />
    <PoweredByLendio v-if="poweredByLendioEnabled" />
  </div>
</template>
<script>
import PoweredByLendio from '~/components/PoweredByLendio.vue';
import EmbeddedSupportInfo from '~/components/embedded/EmbeddedSupportInfo.vue';
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization';
import { mapState } from 'pinia';

export default {
  name: 'AffiliateCustomSidebarWidgets',
  components: {
    EmbeddedSupportInfo,
    PoweredByLendio
  },
  computed: {
    ...mapState(useAffiliateCustomizationStore, [
      'poweredByLendioEnabled',
      'contactInfoEnabled'
    ]),
  }
}
</script>
<style lang="scss" scoped>

.affiliate-custom-widgets {
  display: flex;
  flex-direction: column;
}
</style>
